import React from "react";
export const API_BASE_URL = "https://api.paybiafinance.com/riyms/api/v1";
// export const API_BASE_URL = "http://localhost:3001/riyms/api/v1";

//Live
export const S3_BASE_URL =
  "https://sqlappupload.s3.ap-south-1.amazonaws.com/micro-finence";

export const COMPANY_NAME = "Riyms Micro Foundation";

export const COMPANY_EMAiL = "gHt5R@example.com";
export const COMPANY_MO = "9358807209";
export const COMPANY_Address = "Jaipur, Rajasthan";

export const COMPANY_AddLogo = "img";
export const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date
    .toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(",", "");
};

export const Loader = () => {
  return <span className="loader-new" />;
};

export const MODULE_GROUPS = {
  "EMI Calculator": ["emi-calculator"],
  Directors: ["directors", "directorsCapital"],
  Dealers: ["dealers"],
  Product: ["products"],
  "Manage Staff Data": ["staff-details", "addstaff"],
  Loan: [
    "apply-loan",
    "verification",
    "track-customer-details",
    "download-customer-details",
  ],
  Accounting: [
    "profitandlosslist",
    "bankstatement",
    "banking",
    "ledger",
    "masteraccount",
    "journals",
    "payment",
  ],
  "Loan Status": ["loan-status"],
  Collections: [
    "payment-collection",
    "pending-emi-details"
  ],
  "EMI Record": ["emirecords"],
};
